exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".download {\n  background: #f0f0f1; }\n\n.download i {\n  color: #53a75c;\n  font-size: 30px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src722008540/src/src/app/generic-ui-components/additional-attachment/additional-attachment.component.scss
// module id = ../../../../../src/app/generic-ui-components/additional-attachment/additional-attachment.component.scss
// module chunks = main